import * as Yup from 'yup';

export const validationSchema = Yup.object().shape({
  cause: Yup.number().required('La Causa es requerida')
});

export default validationSchema;
